import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Breadcrumb, Alert } from 'antd';
import moment from 'moment';

import Wrapper from './../../Components/LayoutWrapper';
import SearchWrapper from './../../Components/Common/Search/Orders';
// import OSearch from './../../Components/OSearch';

import OTable from './../../Components/Orders/Components/Table';

import { fetchOrdersCollectionIfNeeded, fetchOrdersSearch, vLoading as ovLoading, fetchOrdersStatisticalData } from './../../Actions/Orders';
import { fetchDestinationCollectionIfNeeded, vLoading } from './../../Actions/DestinationCollection';
import { clearSearchCondition, defaultSearchStatus } from './../../Libs/Orders';

import './Orders.less';

class Orders extends Component {
  state = {
    statisticalData: {
      count: 0,
      farm_cost: 0,
      transaction_amount: 0,
      supplier_offer: 0,
      profit: 0,
      web_settlement: 0,
      num: 0,
    },
    clickFarmData: {
      count: 0,
      farm_cost: 0,
      transaction_amount: 0,
      supplier_offer: 0,
      profit: 0,
      web_settlement: 0,
      num: 0,
    },
    platform: String(this.props.match.params.platform || ''),
    errorPage: String(this.props.match.params.error || ''),
  }
  componentDidMount() {
    this.props.dispatch(ovLoading(true));
    const error = this.props.match.params.error;
    if (error === 'error') {
      const errSearch = JSON.parse(localStorage.getItem('order_lost_product'));
      const initValueErr = {
        ...errSearch,
        'o_id': '',
        'type': 'search-error',
        'dividers_id': localStorage.getItem('dividersIdCurrent') || ''
      };
      this.props.dispatch(fetchOrdersSearch({ page: this.props.match.params.page || 1 }, {},  initValueErr, true));
      this.handleStatisticalData({}, initValueErr);
      return;
    }
    const page = this.props.match.params.page;
    if (page === undefined) {
      this.props.history.push(`/orders/1`);
      return;
    }
    clearSearchCondition();
    const booking_date = [moment().subtract(30, "days").format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')].join(',');
    // const shop_id = this.props.match.params.shopid;
    const initValue = {
      'type': 'search',
      'booking_date': booking_date,
      'is_click_farm': 0,
      'status': defaultSearchStatus.map((item) => item.key).join(','),
      'dividers_id': localStorage.getItem('dividersIdCurrent') || ''
    };
    const fixedValue = {};
    // console.log({ page: this.props.match.params.page || 1 }, initValue, fixedValue, true);
    this.props.dispatch(fetchOrdersCollectionIfNeeded({ page: this.props.match.params.page || 1 }, initValue, fixedValue, true));
    this.handleStatisticalData(initValue, fixedValue);
    // debug:暂时不获取数据
    // this.props.dispatch(ovLoading(false));
  }
  handleStatisticalData(initValue = {}, fixedValue = {}) {
    this.props.dispatch(fetchOrdersStatisticalData(initValue, fixedValue, (err, data) => {
      const param = Object.assign(initValue, fixedValue);
      const validData = data.find(row => row.is_click_farm === Number(param?.is_click_farm  || 0)) || {};
      const robotData = data.find(row => row.is_click_farm === 1) || {};
      this.setState({
        statisticalData: {
          count: validData?.count || 0,
          farm_cost: validData?.farm_cost || 0,
          transaction_amount: validData?.transaction_amount || 0,
          supplier_offer: validData?.supplier_offer || 0,
          profit: validData?.profit || 0,
          web_settlement: validData?.web_settlement || 0,
          num: validData?.num || 0,
        },
        clickFarmData: {
          count: robotData?.count || 0,
          farm_cost: robotData?.farm_cost || 0,
          transaction_amount: robotData?.transaction_amount || 0,
          supplier_offer: robotData?.supplier_offer || 0,
          profit: robotData?.profit || 0,
          web_settlement: robotData?.web_settlement || 0,
          num: robotData?.num || 0,
        }
      });
    }));
  }
  render() {
    const statisticalData = this.state.statisticalData;
    const clickFarmData = this.state.clickFarmData;
    return (
      <Wrapper className={'orders'} meta={{title: '订单列表'}}>
        <Breadcrumb>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/orders/">订单列表</Link></Breadcrumb.Item>
        </Breadcrumb>
        <br />
        {this.state.errorPage === '' && <SearchWrapper
          title="订单查询"
          defaultValue={{
            'sort': {
              'ordersn': 1, 'product_name': 2, 'booking_date': 3, 'saler_id': 4, 'is_shipment': 5, 'status': 6
            },
            'initialValue': {
              // 'saler': { key: '72', label: 'Jyz' },
              'booking_date': [moment().subtract(30, "days"), moment()],
              'is_click_farm': { key: 0, label: '否' },
              'status': defaultSearchStatus,
            },
            'hides': [
              'arrangement', 'profit_margin', 'is_operator_confirm'
            ]
          }}
          onSubmit={(err, str) => {
            this.props.dispatch(ovLoading(true));
            this.props.dispatch(fetchOrdersSearch(str));
            this.handleStatisticalData();
          }} /> }
        <br />
        <Alert message={`总数：${statisticalData.count || 0} 条, 实收金额：${statisticalData.transaction_amount || 0} 元, 成本：${statisticalData.supplier_offer || 0} 元, 利润：${statisticalData.profit} 元, 营收：${statisticalData.web_settlement}, 数量：${statisticalData.num}, 刷单:刷手费用：${clickFarmData.farm_cost}`} type="success" />
        <br />
        <OTable Orders={this.props.Orders} DestinationCollection={this.props.DestinationCollection} currentPage={this.props.match.params.page || 1} showAction={this.state.errorPage===''}/>
      </Wrapper>
    );
  }
}

export default connect((state) => {
  return {
    Orders: state.get('Orders'),
    DestinationCollection: state.get('DestinationCollection')
  };
})(Orders);
